import { useState, useCallback } from 'react';

const useModalVisibility = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const openModal = useCallback(() => setIsModalVisible(true), []);
  const closeModal = useCallback(() => setIsModalVisible(false), []);
  const toggleModal = useCallback(() => {
    setIsModalVisible((prev) => !prev);
  }, []);

  return {
    visible: isModalVisible,
    openModal,
    closeModal,
    toggleModal,
  };
};

export default useModalVisibility;
